import './PageBilan.css';


function PageBilan() {
    return (
        <h1>PageBilan</h1>
    );
}

export default PageBilan

